var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('auction-dialog', {
    attrs: {
      "title": "응찰하기",
      "showsActions": "",
      "width": "1034"
    },
    on: {
      "open": _vm.init,
      "close": _vm.destroy
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }, {
      key: "default",
      fn: function fn() {
        return [_c('auction-bids-data', {
          ref: "bids-data",
          attrs: {
            "bids": _vm.bids
          }
        })];
      },
      proxy: true
    }, {
      key: "actions",
      fn: function fn() {
        return [_c('v-card', {
          staticClass: "v-card--default-outlined",
          attrs: {
            "outlined": "",
            "tile": ""
          }
        }, [_c('v-card-text', {
          staticClass: "pa-20 pa-30"
        }, [_c('div', {
          staticClass: "mt-n6"
        }, _vm._l(_vm.priceInfo, function (price) {
          var _price$desc, _price$desc$format;

          return _c('v-row', {
            key: price.term,
            staticClass: "mt-6",
            attrs: {
              "no-gutters": ""
            }
          }, [_c('v-col', {
            attrs: {
              "cols": "5"
            }
          }, [_c('span', {
            staticClass: "font-size-14 font-size-md-16 primary--text"
          }, [_vm._v(_vm._s(price.term))])]), _c('v-col', {
            staticClass: "grey-68--text",
            attrs: {
              "cols": "7"
            }
          }, [_c('span', {
            staticClass: "font-size-14 font-size-md-16 pl-md-10",
            class: {
              'font-weight-bold primary--text': price.bold
            }
          }, [_vm._v(_vm._s((_price$desc = price.desc) === null || _price$desc === void 0 ? void 0 : (_price$desc$format = _price$desc.format) === null || _price$desc$format === void 0 ? void 0 : _price$desc$format.call(_price$desc)))])])], 1);
        }), 1), _c('v-divider', {
          staticClass: "my-20"
        }), _c('v-row', {
          attrs: {
            "no-gutters": "",
            "align": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "5"
          }
        }, [_c('span', {
          staticClass: "font-size-14 font-size-md-16 primary--text"
        }, [_vm._v("응찰가")])]), _c('v-col', {
          attrs: {
            "cols": "7"
          }
        }, [_c('div', {
          staticClass: "pl-md-10"
        }, [_c('auction-actions-prices', _vm._b({
          model: {
            value: _vm.inputs.price,
            callback: function callback($$v) {
              _vm.$set(_vm.inputs, "price", $$v);
            },
            expression: "inputs.price"
          }
        }, 'auction-actions-prices', _vm.attrs_prices, false))], 1)])], 1), _c('v-row', {
          staticClass: "mt-6",
          attrs: {
            "no-gutters": "",
            "align": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "5"
          }
        }, [_c('auction-until', {
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref2) {
              var attrs = _ref2.attrs,
                  on = _ref2.on;
              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "v-btn--none-active-bg px-0",
                attrs: {
                  "text": "",
                  "height": "30"
                }
              }, 'v-btn', attrs, false), on), [_vm._v("자동응찰"), _c('i', {
                staticClass: "icon icon-help-circle-outline ml-6 ml-md-8"
              })])];
            }
          }])
        })], 1), _c('v-col', {
          attrs: {
            "cols": "7"
          }
        }, [_c('div', {
          staticClass: "pl-md-10"
        }, [_c('auction-actions-prices', _vm._b({
          attrs: {
            "test": function test(value) {
              return value > _vm.inputs.price;
            },
            "optional": ""
          },
          model: {
            value: _vm.inputs.price_until,
            callback: function callback($$v) {
              _vm.$set(_vm.inputs, "price_until", $$v);
            },
            expression: "inputs.price_until"
          }
        }, 'auction-actions-prices', _vm.attrs_prices, false))], 1)])], 1), _c('v-divider', {
          staticClass: "my-20"
        }), _c('div', [_c('p', {
          staticClass: "font-size-14 grey-68--text"
        }, [_vm._v(" * 최고 응찰가가 동일한 경우"), _c('br'), _vm._v(" 먼저 참여한 응찰자에게 낙찰됩니다. ")])]), _c('div', {
          staticClass: "mt-18 mt-md-24"
        }, [_c('v-btn', {
          attrs: {
            "block": "",
            "x-large": "",
            "color": "primary",
            "disabled": _vm.isLastBidder,
            "loading": _vm.loading_btn,
            "dark": !_vm.isLastBidder
          },
          on: {
            "click": _vm.makeBid
          }
        }, [_vm._v("응찰하기")])], 1)], 1)], 1)];
      },
      proxy: true
    }], null, true)
  });
}
var staticRenderFns = []

export { render, staticRenderFns }